<template>
  <div class="dovemed-container mt-0">
    <div class="dovemed-wrapper text-center signup-page">
      <div class="signup-container mt-5" v-bind:style="{ 'max-width': '700px' }">
        <h2 class="hyper-link mb-3 font-weight-bold welcome-message">
          <div>Welcome to</div>
          <div>{{ currentCircle.condition_type }}{{ !currentCircle.condition_type.toLowerCase().includes("circle") ? " Circle" : "" }}</div>
        </h2>
        <p class="get-started">
          {{ $route.query.role === "patient" ? "To get started, tell us a bit more about yourself." : "To get started, tell us a bit more about your patient" }}
        </p>
        <div class="row m-0 profile-form">
          <div class="profile-form__card">
            <div class="user-wrapper">
              <div class="user-avatar">
                <img src="../../../assets/images/user-profile.png" alt="user profile" :style="{ width: '15px', height: '18px' }" />
              </div>
              <div class="registering-message">You are registering as a {{ $route.query.role }}</div>
            </div>
            <div class="change" @click="$router.go(-1)" :style="{ color: getPrimaryColor() }">Change</div>
          </div>

          <!-- CAREGIVER -->
          <div v-if="$route.query.role === 'caregiver'" :class="`col-sm-12 formWrapper col-md-12`">
            <div class="row">
              <div class="col-md-12 col-sm-12 text-left mb-2">
                <label for="displayName" class="mb-1 input-label">
                  Display Name
                  <span class="required">*</span>
                  <a-tooltip placement="topLeft" overlayClassName="ant-dovemed-tooltip">
                    <template slot="title">
                      <span> To protect your privacy and identity, you may choose to have a unique display name, and avoid your first name and last name. </span>
                    </template>
                    <!-- ${currentCircle.color_code} -->
                    <i class="fa fa-question-circle question-icon" aria-hidden="true" :style="`color:#2A71D4 !important`"></i>
                  </a-tooltip>
                </label>
                <a-input
                  :size="'large'"
                  placeholder="Provide unique display name"
                  v-model.lazy="$v.formResponses.displayName.$model"
                  ref="displayNameInput"
                  :class="`formInput ${namePassed ? 'green' : 'red'} br8`"
                />
                <!-- <font-awesome-icon :icon="['fas', 'check-circle']"/> -->
                <div class="error-container" v-if="$v.formResponses.displayName.$error">
                  <div class="error-item" v-if="!$v.formResponses.displayName.required">Display name is required</div>
                  <div class="error-item" v-if="!$v.formResponses.displayName.minLength">Minimum length is 6</div>
                  <div class="error-item" v-if="!$v.formResponses.displayName.maxLength">Maximum length is 12</div>
                  <div class="error-item" v-if="!$v.formResponses.displayName.isUnique">Display name already taken</div>
                  <div class="error-item" v-if="!$v.formResponses.displayName.alphaNumAndDotValidator">No special characters allowed</div>
                </div>
              </div>
            </div>

            <div v-if="$route.query.role === 'caregiver'" class="pat_info">
              <h2>Patient’s Information</h2>
              <input type="checkbox" class="check-box" :checked="provideInfo" @change="toggleProvideInfo" />
              <span>I would rather not say</span>
            </div>
            <div v-if="provideInfo" class="switch-adv col-12" :style="{ background: getPrimary50Color() }">
              <p>The patient’s information is mandatory when you register as a caregiver. If you wish not to show this information you can register as an Advocate.</p>
              <div
                @click="
                  $router.push({
                    name: 'UserProfileWelcomeAdvocate',
                    params: { role: 'advocate' },
                    query: { role: 'advocate' },
                  })
                "
                v-bind:style="{ background: getPrimaryColor() }"
              >
                register as advocate
              </div>
            </div>
            <div v-if="!provideInfo">
              <div class="row mt-3 align-items-end">
                <!-- v-if="circleDiseaseTypes.length!==0" -->
                <div class="col-md-6 col-sm-12 text-left mb-2 type-input">
                  <label for="ibsType" class="mb-1 input-label">
                    <!-- {{ $route.query.role === "caregiver" ? `Patient's` : "My" }} -->
                    Type of
                    <span class="input-label text-capitalize">{{
                      currentCircle.condition_type
                        .toLowerCase()
                        .replace("circle", "")
                        .replace("my", "")
                    }}</span>
                    <!-- <span v-if="circleDiseaseTypes.length!==0" class="required">*</span> -->
                  </label>
                  <div class>
                    <a-select :size="'large'" class="w-100" placeholder="Select Type" style="height: 56px" v-model="$v.formResponses.ibsType.$model" :disabled="circleDiseaseTypes.length === 0">
                      <a-select-option :value="disease.display_name" v-for="disease in circleDiseaseTypes" :key="disease.id" @click="() => handleTypeChange(disease)">{{
                        disease.display_name
                      }}</a-select-option>
                    </a-select>
                    <div class="error-container" v-if="$v.formResponses.ibsType.$error">
                      <div class="error-item" v-if="!$v.formResponses.ibsType.required">Required</div>
                    </div>
                  </div>
                </div>
                <div class="col-md-6 col-sm-12 text-left mb-2 type-input">
                  <label for="birthday" class="mb-1 input-label">
                    {{ $route.query.role === "caregiver" ? `Patient's` : "My" }}
                    Birthday
                    <span class="required">*</span>
                  </label>
                  <!-- <a-month-picker
                    :allowClear="true"
                    class="d-inline-block pr-0 w-100"
                    :size="'large'"
                    :defaultValue="formResponses.birthDate"
                    placeholder="Provide month and year"
                    @change="handleBirthDateChange"
                    :disabled-date="tempValue => tempValue >= new Date()"
                  >
                    <template v-if="formResponses.birthDate" #suffixIcon>
                      <font-awesome-icon
                        :icon="['far', 'times']"
                        class="gray400 cp show-in-mobile"
                        @click="
                          () => {
                            formResponses.birthDate = null
                          }
                        "
                      />
                    </template>
                  </a-month-picker> -->
                  <DatePicker
                    :disabled-date="tempValue => tempValue >= new Date()"
                    placeholder="Provide month and year"
                    v-model="formResponses.birthDate"
                    type="month"
                    class="w-100 new-datepicker"
                    :clearable="false"
                    :append-to-body="false"
                  />
                  <div class="error-container" v-if="$v.formResponses.birthDate.$error"></div>
                </div>
              </div>
              <div class="row mt-3">
                <div class="col-md-6 col-sm-12 text-left mb-2 type-input">
                  <label for="diagnosisDate" class="mb-1 input-label">
                    <!-- {{ $route.query.role === "caregiver" ? `Patient's` : "My" }} -->
                    Date of Diagnosis
                  </label>
                  <!-- <a-month-picker
                    :allowClear="true"
                    class="d-inline-block pr-0 w-100"
                    :size="'large'"
                    placeholder="Diagnosis date"
                    :disabled-date="disabledDiagnosisDates"
                    :disabled="!formResponses.birthDate"
                    @change="handleDiagnosisDateChange"
                    v-model="formResponses.diagnosisDate"
                  >
                    <template v-if="formResponses.diagnosisDate" #suffixIcon>
                      <font-awesome-icon
                        :icon="['far', 'times']"
                        class="gray400 cp show-in-mobile"
                        @click="
                          () => {
                            formResponses.diagnosisDate = null
                          }
                        "
                      />
                    </template>
                  </a-month-picker> -->
                  <DatePicker
                    :disabled-date="disabledDiagnosisDates"
                    :disabled="!formResponses.birthDate"
                    placeholder="Diagnosis date"
                    v-model="formResponses.diagnosisDate"
                    type="month"
                    class="w-100 new-datepicker"
                    :clearable="false"
                    :append-to-body="false"
                  />
                  <div class="error-container" v-if="$v.formResponses.diagnosisDate.$error"></div>
                </div>
                <div class="col-md-6 col-sm-12 text-left mb-2 type-input">
                  <label for="gender" class="mb-1 input-label">
                    {{ $route.query.role === "caregiver" ? `Patient's` : "" }}
                    Gender
                    <!-- <span class="required">*</span> -->
                  </label>
                  <div class>
                    <a-select :size="'large'" class="w-100" :defaultValue="formResponses.gender" placeholder="Select gender" style="width: 120px" v-model="$v.formResponses.gender.$model">
                      <a-select-option value="" disabled>Select</a-select-option>
                      <a-select-option value="male">Male</a-select-option>
                      <a-select-option value="female">Female</a-select-option>
                      <a-select-option value="other">Other</a-select-option>
                    </a-select>
                    <div class="error-container" v-if="$v.formResponses.gender.$error"></div>
                  </div>
                </div>
              </div>
              <div class="row mt-3">
                <div class="col-md-6 col-sm-12 text-left mb-2 type-input position-relative">
                  <font-awesome-icon :icon="['fal', 'search']" class="position-absolute search-icon gray400 font20" />
                  <label for="city" class="mb-1 input-label">
                    City
                    <span class="required">*</span>
                  </label>
                  <a-select
                    show-search
                    :allowClear="true"
                    :size="'large'"
                    class="w-100 citySelect"
                    placeholder="Search City"
                    style="width: 120px"
                    :default-active-first-option="false"
                    :show-arrow="false"
                    :filter-option="false"
                    :defaultValue="formResponses.city ? formResponses.city + ' , ' + formResponses.state : undefined"
                    @search="val => getLocations(val)"
                    @select="val => selectLocation(val)"
                  >
                    <a-select-option v-if="loadingLocation" :key="0" :disabled="true">
                      <span> <a-spin size="small" class="mr-2" /> Loading... </span>
                    </a-select-option>
                    <template v-else>
                      <a-select-option v-for="c in locationsList" :key="JSON.stringify(c)">{{ c.name }}, {{ c.state }} </a-select-option>
                    </template>
                  </a-select>
                  <div
                    :style="{
                      color: '#94A3B8',
                      // 'font-style': 'italic',
                      'font-weight': '400',
                      'font-size': '12px',
                    }"
                  >
                    MyCircles is currently only available in the USA
                  </div>
                  <div class="error-container" v-if="$v.formResponses.city.$error">
                    <div class="error-item" v-if="!$v.formResponses.city.required">City is required</div>
                  </div>
                </div>
                <div class="col-md-6 col-sm-12 text-left mb-2 type-input">
                  <label for="zipcode" class="mb-1 input-label"> Zipcode </label>
                  <br />
                  <!-- add auto complete here -->
                  <a-select
                    class="w-100"
                    :allowClear="true"
                    :min="0"
                    :size="'large'"
                    placeholder="Search Zipcode"
                    :defaultValue="formResponses.zip_code"
                    v-model="$v.formResponses.zip_code.$model"
                    :disabled="formResponses.city ? false : true"
                  >
                    <a-select-option v-if="loadingZipCodes" :key="0" :disabled="true">
                      <span> <a-spin size="small" class="mr-2" /> Loading... </span>
                    </a-select-option>
                    <template v-else>
                      <a-select-option v-for="zipcode in zipCodeArray" :key="zipcode"> {{ zipcode }} </a-select-option>
                    </template>
                  </a-select>
                  <div class="error-container" v-if="$v.formResponses.zip_code.$error"></div>
                </div>
              </div>

              <!-- <div class="row mt-3">
              <div class="col-md-6 col-sm-12 text-left mb-2">
                <label for="country" class="mb-1 input-label">
                  Country
                  <span class="required">*</span>
                </label>
                <a-input
                  :size="'large'"
                  class="w-100"
                  placeholder="Country"
                  style="width: 120px"
                  :disabled="true"
                  v-model="$v.formResponses.country.$model"
                />
                <div
                  class="error-container"
                  v-if="$v.formResponses.country.$error"
                >
                  <div
                    class="error-item"
                    v-if="!$v.formResponses.country.required"
                  >
                    Country is required
                  </div>
                </div>
              </div>
            </div> -->
              <!-- <div class="row mt-3">
              <div class="col-md-12 col-sm-12 text-left mb-2">
                <p class="m-0 d-block">
                  {{
                    $route.query.role === "caregiver"
                      ? `Does the patient have any additional conditions?`
                      : "Do you have any additional conditions?"
                  }}
                  <i class="font-light">- Optional</i>
                </p>
                <p class="mb-2 d-block font-light">
                  (For ex. depression, anxiety etc..)
                </p>
              </div>
              <div class="col-md-12 col-sm-12 text-left mb-2">
                <a-select
                  mode="tags"
                  :size="'large'"
                  placeholder="ex. depression, anxiety etc.."
                  allowClear
                  filterOption
                  class="w-100 c-select"
                  @change="handleTags"
                  @select="changeColor"
                >
                  <a-select-option v-for="i in 'a'" :key="i" disabled
                    >Start typing</a-select-option
                  >
                </a-select>
                
              </div>
            </div> -->
            </div>

            <div v-if="!provideInfo" class="buttons-groups mt-4 col-12 mb-4">
              <div class="d-flex align-items-center">
                <a-checkbox class="checkbox-verify" :checked="isAgeVerify" @change="onCheck"> I'm at least 18 years old. </a-checkbox>
                <span class="required" :style="{ display: 'contents' }">*</span>
              </div>
              <div class="btn-cont">
                <button
                  class="dovemed-button hyper-link"
                  :style="{
                    color: '#47556E',
                    background: '#E2E8F0',
                  }"
                  @click="redirectBack()"
                >
                  Back
                </button>
                <a-button
                  :loading="loading"
                  :disabled="!formResponses.displayName || !isAgeVerify || !formResponses.city || !formResponses.birthDate"
                  type="submit"
                  class="next-button font-white primary-button"
                  :style="{
                    background: getPrimaryColor(),
                    color: '#fff !important',
                    opacity: formResponses.displayName && isAgeVerify && formResponses.city && formResponses.birthDate ? '1' : '0.3',
                    border: 'none',
                  }"
                  @click.prevent="handleSubmit"
                >
                  <!-- :style="{
                  background: isAgeVerify && formResponses.displayName && formResponses.city
                    ? getPrimaryColor()
                    : getAlphaPrimaryColor(),
                  color: '#fff !important'
                }" -->
                  <span :style="{ color: '#fff !important' }">Next</span>
                </a-button>
              </div>
            </div>
          </div>

          <!-- PATIENT -->
          <div v-if="$route.query.role === 'patient'" class="col-sm-12 formWrapper" v-bind:class="$route.query.role === 'caregiver' ? 'col-md-8' : 'col-md-12'">
            <div class="row">
              <div class="col-md-12 col-sm-12 text-left mb-2">
                <label for="displayName" class="mb-1 input-label">
                  Display Name
                  <span class="required">*</span>
                  <a-tooltip placement="topLeft" overlayClassName="ant-dovemed-tooltip">
                    <template slot="title">
                      <span> To protect your privacy and identity, you may choose to have a unique display name, and avoid your first name and last name. </span>
                    </template>
                    <!-- ${currentCircle.color_code} -->
                    <i class="fa fa-question-circle question-icon" aria-hidden="true" :style="`color:#2A71D4 !important`"></i>
                  </a-tooltip>
                </label>
                <a-input
                  :size="'large'"
                  placeholder="Provide unique display name"
                  v-model.lazy="$v.formResponses.displayName.$model"
                  ref="displayNameInput"
                  :class="`formInput ${namePassed ? 'green' : 'red'} br8`"
                />
                <!-- <font-awesome-icon :icon="['fas', 'check-circle']"/> -->
                <div class="error-container" v-if="$v.formResponses.displayName.$error">
                  <div class="error-item" v-if="!$v.formResponses.displayName.required">Display name is required</div>
                  <div class="error-item" v-if="!$v.formResponses.displayName.minLength">Minimum length is 6</div>
                  <div class="error-item" v-if="!$v.formResponses.displayName.isUnique">Display name already taken</div>
                  <div class="error-item" v-if="!$v.formResponses.displayName.alphaNumAndDotValidator">No special characters allowed</div>
                </div>
              </div>
            </div>

            <!-- <div v-if="$route.query.role === 'caregiver'" class="pat_info">
              <h2>Patient’s Information</h2>
              <input
                type="checkbox"
                class="check-box"
                :checked="provideInfo"
                @change="toggleProvideInfo"
              />
              <span>I would rather not say</span>
            </div>
            <div
              v-if="provideInfo"
              class="switch-adv col-12"
              v-bind:style="{ background: getAlphaPrimaryColor() }"
            >
              <p>
                The patient’s information is mandatory when you register as a
                caregiver. If you wish not to show this information you can
                register as an Advocate.
              </p>
              <div
                @click=" handleAdvocateModal"
                v-bind:style="{ background: getPrimaryColor() }"
              >
                register as advocate
              </div>
            </div> -->

            <!-- ================================================== PROVIDE INFO WHEN TYPE IS NOT THERE -->
            <!-- <div v-if="!provideInfo && circleDiseaseTypes.length === 0">
              <div class="row mt-3">
                <div class="col-md-6 col-sm-12 text-left mb-2 type-input">
                  <label for="diagnosisDate" class="mb-1 input-label">
                    Date of Diagnosis
                  </label>
                  <a-month-picker
                    class="d-inline-block pr-0 w-100"
                    :size="'large'"
                    placeholder="Diagnosis date"
                    :disabled-date="tempValue => tempValue >= new Date()"
                    @change="handleDiagnosisDateChange"
                  />
                  <div
                    class="error-container"
                    v-if="$v.formResponses.diagnosisDate.$error"
                  ></div>
                </div>
                <div class="col-md-6 col-sm-12 text-left mb-2 type-input">
                  <label for="birthday" class="mb-1 input-label">
                    {{ $route.query.role === "caregiver" ? `Patient's` : "My" }}
                    Birthday
                  </label>
                  <a-month-picker
                    class="d-inline-block pr-0 w-100"
                    :size="'large'"
                    placeholder="Provide month and year"
                    :disabled-date="
                      tempValue => tempValue.isAfter(this.afterYear)
                    "
                    @change="handleBirthDateChange"
                  />
                  <div
                    class="error-container"
                    v-if="$v.formResponses.birthDate.$error"
                  ></div>
                </div>
              </div>
              <div class="row mt-3">
                <div class="col-md-6 col-sm-12 text-left mb-2 type-input">
                  <label for="gender" class="mb-1 input-label">
                    {{ $route.query.role === "caregiver" ? `Patient's` : "" }}
                    Gender
                  </label>
                  <div class>
                    <a-select
                      :size="'large'"
                      class="w-100"
                      defaultValue="male"
                      placeholder="Select gender"
                      style="width: 120px"
                      v-model="$v.formResponses.gender.$model"
                    >
                      <a-select-option value="male">Male</a-select-option>
                      <a-select-option value="female">Female</a-select-option>
                      <a-select-option value="other">Other</a-select-option>
                    </a-select>
                    <div
                      class="error-container"
                      v-if="$v.formResponses.gender.$error"
                    ></div>
                  </div>
                </div>
                <div class="col-md-6 col-sm-12 text-left mb-2 type-input">
                  <label for="city" class="mb-1 input-label">
                    City
                    <span class="required">*</span>
                  </label>
                  <a-select
                    show-search
                    :size="'large'"
                    class="w-100"
                    placeholder="Search City"
                    style="width: 120px"
                    :default-active-first-option="false"
                    :show-arrow="false"
                    :filter-option="false"
                    :defaultValue="formResponses.city"
                    @search="val => getLocations(val)"
                    @select="val => selectLocation(val)"
                  >
                    <a-select-option
                      v-for="c in locationsList"
                      :key="JSON.stringify(c)"
                      >{{ c.city }}, {{ c.state }}
                    </a-select-option>
                  </a-select>
                  <div
                    :style="{
                      color: '#94A3B8',
                      'font-weight': '400',
                      'font-size': '12px'
                    }"
                  >
                    MyCircles is currently only available in the USA
                  </div>
                  <div
                    class="error-container"
                    v-if="$v.formResponses.city.$error"
                  >
                    <div
                      class="error-item"
                      v-if="!$v.formResponses.city.required"
                    >
                      City is required
                    </div>
                  </div>
                </div>
              </div>
              <div class="row mt-3">
                <div class="col-md-6 col-sm-12 text-left mb-2 type-input">
                  <label for="zipcode" class="mb-1 input-label">
                    Zipcode
                  </label>
                  <br />
                  <a-select
                    class="w-100"
                    :min="0"
                    :size="'large'"
                    placeholder="Search Zipcode"
                    v-model="$v.formResponses.zip_code.$model"
                    :disabled="formResponses.city ? false : true"
                  >
                    <a-select-option
                      v-for="zipcode in zipCodeArray"
                      :key="zipcode"
                    >
                      {{ zipcode }}
                    </a-select-option>
                  </a-select>
                  <div
                    class="error-container"
                    v-if="$v.formResponses.zip_code.$error"
                  ></div>
                </div>
              </div>
            </div> -->

            <!-- PROVIDE INFO WHEN TYPE IS THERE -->
            <div v-if="!provideInfo">
              <div class="row mt-3 align-items-end">
                <div class="col-md-6 col-sm-12 text-left mb-2 type-input">
                  <label for="ibsType" class="mb-1 input-label">
                    <!-- {{ $route.query.role === "caregiver" ? `Patient's` : "My" }} -->
                    Type of
                    <span class="input-label text-capitalize">{{
                      currentCircle.condition_type
                        .toLowerCase()
                        .replace("circle", "")
                        .replace("my", "")
                    }}</span>
                  </label>
                  <div class="position-relative" ref="conditionTypeContainer">
                    <a-select :size="'large'" class="w-100" placeholder="Select Type" style="height: 56px" v-model="$v.formResponses.ibsType.$model" :disabled="circleDiseaseTypes.length === 0">
                      <a-select-option :value="disease.display_name" v-for="disease in circleDiseaseTypes" :key="disease.id" @click="() => handleTypeChange(disease)">{{
                        disease.display_name
                      }}</a-select-option>
                    </a-select>
                    <div class="error-container" v-if="$v.formResponses.ibsType.$error">
                      <div class="error-item" v-if="!$v.formResponses.ibsType.required">Required</div>
                    </div>
                  </div>
                </div>

                <div class="col-md-6 col-sm-12 text-left mb-2 type-input bday-date-container position-relative">
                  <label for="birthday" class="mb-1 input-label">
                    {{ $route.query.role === "caregiver" ? `Patient's` : "My" }}
                    Birthday
                    <span class="required">*</span>
                  </label>
                  <!-- <a-month-picker
                    :allowClear="true"
                    class="d-inline-block pr-0 w-100"
                    :size="'large'"
                    placeholder="Provide month and year"
                    @change="handleBirthDateChange"
                    :defaultPickerValue="maxBirthdayDate"
                    :disabled-date="tempValue => tempValue > maxBirthdayDate"
                  >
                    <template v-if="formResponses.birthDate" #suffixIcon>
                      <font-awesome-icon
                        :icon="['far', 'times']"
                        class="gray400 cp show-in-mobile"
                        @click="
                          () => {
                            formResponses.birthDate = null
                          }
                        "
                      />
                    </template>
                  </a-month-picker> -->
                  <DatePicker
                    :disabled-date="tempValue => tempValue > maxBirthdayDate"
                    placeholder="Provide month and year"
                    v-model="formResponses.birthDate"
                    type="month"
                    class="w-100 new-datepicker"
                    :clearable="false"
                    :default-value="maxBirthdayDate"
                    :append-to-body="false"
                  />
                  <div class="error-container" v-if="$v.formResponses.birthDate.$error"></div>
                </div>
              </div>

              <div class="row mt-3">
                <div class="col-md-6 col-sm-12 text-left mb-2 type-input" ref="diagnosisDateContainer">
                  <label for="diagnosisDate" class="mb-1 input-label">
                    Date of Diagnosis
                  </label>
                  <!-- <a-month-picker
                    :allowClear="true"
                    class="d-inline-block pr-0 w-100"
                    :size="'large'"
                    placeholder="Diagnosis date"
                    :disabled-date="disabledDiagnosisDates"
                    @change="handleDiagnosisDateChange"
                    :disabled="!formResponses.birthDate"
                    v-model="formResponses.diagnosisDate"
                  >
                    <template v-if="formResponses.diagnosisDate" #suffixIcon>
                      <font-awesome-icon
                        :icon="['far', 'times']"
                        class="gray400 cp show-in-mobile"
                        @click="
                          () => {
                            formResponses.diagnosisDate = null
                          }
                        "
                      />
                    </template>
                  </a-month-picker> -->
                  <DatePicker
                    :disabled-date="disabledDiagnosisDates"
                    placeholder="Diagnosis date"
                    :disabled="!formResponses.birthDate"
                    v-model="formResponses.diagnosisDate"
                    type="month"
                    class="w-100 new-datepicker"
                    :clearable="false"
                    :append-to-body="false"
                  />
                  <div class="error-container" v-if="$v.formResponses.diagnosisDate.$error"></div>
                </div>
                <div class="col-md-6 col-sm-12 text-left mb-2 type-input gender-container">
                  <label for="gender" class="mb-1 input-label">
                    {{ $route.query.role === "caregiver" ? `Patient's` : "" }}
                    Gender
                    <!-- <span class="required">*</span> -->
                  </label>
                  <a-select :size="'large'" class="w-100" :defaultValue="formResponses.gender" placeholder="Select gender" style="width: 120px" v-model="$v.formResponses.gender.$model">
                    <!-- :getPopupContainer="() => document.getElementsByClassName('gender-container')[0]" -->
                    <a-select-option value="" disabled>Select</a-select-option>
                    <a-select-option value="male">Male</a-select-option>
                    <a-select-option value="female">Female</a-select-option>
                    <a-select-option value="other">Other</a-select-option>
                  </a-select>
                  <div class="error-container" v-if="$v.formResponses.gender.$error"></div>
                </div>
              </div>
              <div class="row mt-3">
                <div class="col-md-6 col-sm-12 text-left mb-2 type-input position-relative">
                  <font-awesome-icon :icon="['fal', 'search']" class="position-absolute search-icon gray400 font20" />
                  <label for="city" class="mb-1 input-label">
                    City
                    <span class="required">*</span>
                  </label>
                  <a-select
                    show-search
                    :allowClear="true"
                    :size="'large'"
                    class="w-100 citySelect"
                    placeholder="Search City"
                    style="width: 120px"
                    :default-active-first-option="false"
                    :show-arrow="false"
                    :filter-option="false"
                    :defaultValue="formResponses.city ? formResponses.city + ' , ' + formResponses.state : undefined"
                    @search="val => getLocations(val)"
                    @select="val => selectLocation(val)"
                  >
                    <a-select-option v-if="loadingLocation" :key="0" :disabled="true">
                      <span> <a-spin size="small" class="mr-2" /> Loading... </span>
                    </a-select-option>
                    <template v-else>
                      <a-select-option v-for="c in locationsList" :key="JSON.stringify(c)">{{ c.name }}, {{ c.state }} </a-select-option>
                    </template>
                  </a-select>
                  <div
                    :style="{
                      color: '#94A3B8',
                      // 'font-style': 'italic',
                      'font-weight': '400',
                      'font-size': '12px',
                    }"
                  >
                    MyCircles is currently only available in the USA
                  </div>
                  <div class="error-container" v-if="$v.formResponses.city.$error">
                    <div class="error-item" v-if="!$v.formResponses.city.required">City is required</div>
                  </div>
                </div>
                <div class="col-md-6 col-sm-12 text-left mb-2 type-input">
                  <label for="zipcode" class="mb-1 input-label"> Zipcode </label>
                  <br />
                  <!-- add auto complete here -->
                  <a-select
                    class="w-100"
                    :min="0"
                    :size="'large'"
                    :allowClear="true"
                    placeholder="Search Zipcode"
                    :defaultValue="formResponses.zipcode"
                    v-model="$v.formResponses.zip_code.$model"
                    :disabled="formResponses.city ? false : true"
                  >
                    <a-select-option v-if="loadingZipCodes" :key="0" :disabled="true">
                      <span> <a-spin size="small" class="mr-2" /> Loading... </span>
                    </a-select-option>
                    <template v-else>
                      <a-select-option v-for="zipcode in zipCodeArray" :key="zipcode"> {{ zipcode }} </a-select-option>
                    </template>
                  </a-select>
                  <div class="error-container" v-if="$v.formResponses.zip_code.$error"></div>
                </div>
              </div>
            </div>

            <div v-if="!provideInfo" class="buttons-groups mt-4 col-12 mb-4">
              <div class="d-flex align-items-center">
                <a-checkbox class="checkbox-verify" :checked="isAgeVerify" @change="onCheck"> I'm at least 18 years old. </a-checkbox>
                <span class="required" :style="{ display: 'contents' }">*</span>
              </div>
              <div class="btn-cont">
                <button
                  class="dovemed-button hyper-link fw700"
                  :style="{
                    color: '#47556E',
                    background: '#E2E8F0',
                  }"
                  @click="redirectBack()"
                >
                  Back
                </button>
                <!-- /[^0-9]/.test(formResponses.displayName) -->
                <!-- MANDATORY FIELDS -> name, city, 18+ age -->
                <a-button
                  :loading="loading"
                  :disabled="!formResponses.displayName || !formResponses.city || !isAgeVerify || !formResponses.birthDate"
                  type="submit"
                  class="next-button font-white primary-button"
                  :style="{
                    background: getPrimaryColor(),
                    color: '#fff !important',
                    opacity: isAgeVerify && formResponses.displayName && formResponses.city && formResponses.birthDate ? '1' : '0.3',
                    border: 'none',
                  }"
                  @click.prevent="handleSubmit"
                >
                  <span class="fw700 font-white">Next</span>
                </a-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <AddAdvocateModal ref="AddAdvocateModal" />
    <SuggestCircleForTypeModal ref="suggestCircle" />
  </div>
</template>

<script>
import { mapGetters } from "vuex"
import { required, minLength, maxLength, email, requiredIf, helpers } from "vuelidate/lib/validators"
import Repository from "../../../repositories/Repository"
import { RepositoryFactory } from "../../../repositories/RepositoryFactory"
import AddAdvocateModal from "../../Modals/AddAdvocateModal.vue"
import DatePicker from "vue2-datepicker"
import SuggestCircleForTypeModal from "../../Modals/SuggestCircleForTypeModal.vue"
import axios from "axios"

const AppRepository = RepositoryFactory.get("app")
const CircleRepository = RepositoryFactory.get("circle")
const alphaNumAndDotValidator = helpers.regex("alphaNumAndDotValidator", /^(?=.*?[a-zA-Z])[\w]{6,12}$/)
// /[^0-9]/
// ^[a-zA-Z0-9](_(?!(\.|_))|\.(?!(_|\.))|[a-zA-Z0-9]){4,10}[a-zA-Z0-9]$

export default {
  name: "UserProfileWelcome",
  components: { AddAdvocateModal, SuggestCircleForTypeModal, DatePicker },
  data() {
    return {
      authenticated: false,
      maxBirthdayDate: "",
      uiState: "submit_not_clicked",
      loading: false,
      empty: true,
      errors: false,
      country: [],
      state: [],
      locationsList: [],
      monthFormat: "YYYY-MM",
      zipCodeArray: [],
      formResponses: {
        displayName: null,
        displayNameResponse: null,
        password: null,
        email: null,
        gender: null,
        // gender: "male",
        birthDate: undefined,
        ibsType: undefined,
        diagnosisDate: null,
        additionalConditions: null,
        role: null,
        address_line1: null,
        address_line2: null,
        city: undefined,
        state: null,
        country: "USA",
        zip_code: undefined,
      },
      namePassed: false,
      provideInfo: false,
      value: null,
      isAgeVerify: false,
      afterYear: `${new Date().getFullYear() - 17}-01`,
      // checkAllFieldsFilled : false
      loadingLocation: false,
      loadingZipCodes: false,
      suggested_circle: null,
    }
  },
  watch: {
    "formResponses.displayName": {
      handler(val) {
        // console.log("watch handler is running")
        if (/^(?=.*?[a-zA-Z])[\w]{6,12}$/.test(val)) {
          this.namePassed = true
        } else {
          this.namePassed = false
        }
      },
      immediate: true,
      deep: true,
    },
    "formResponses.birthDate": {
      handler(date) {
        if (this.formResponses.diagnosisDate && new Date(date) > new Date(this.formResponses.diagnosisDate)) {
          this.formResponses.diagnosisDate = new Date(date)
        }
      },
    },
  },
  validations: {
    formResponses: {
      displayName: {
        required,
        minLength: minLength(6),
        maxLength: maxLength(12),
        alphaNumAndDotValidator,
        isUnique(value) {
          // standalone validator ideally should not assume a field is required
          if (value === "") return true

          // simulate async call, fail for all logins with even length
          return new Promise((resolve, reject) => {
            const url = `${process.env.BASE_API_URL}/displaynamecheck/?key=${this.formResponses.displayName}`
            this.$http
              .get(url)
              .then(result => {
                // console.log("Result in display name checking", result);
                if (result.status === 200) {
                  this.formResponses.displayNameResponse = result.data
                }
                resolve(result.data.status === 200)
              })
              .catch(err => reject(err))
          })
        },
      },
      password: {
        minLength: minLength(6),
        required: requiredIf(function() {
          return !this.authUser
        }),
        //   strongPassword(password1) {
        //   return (
        //     /[a-z]/.test(password1) && //checks for a-z
        //     /[0-9]/.test(password1) && //checks for 0-9
        //     /\W|_/.test(password1) && //checks for special char
        //     password1.length >= 8
        //   )
        // }
      },
      email: {
        required,
        email,
      },
      gender: {
        //required
      },
      birthDate: {
        // required
      },
      ibsType: {
        required,
      },
      diagnosisDate: {
        //required
      },
      additionalConditions: {
        // required
      },
      role: {
        required,
      },
      // address: {
      city: {
        required,
      },
      state: {
        //required
      },
      country: {
        //required
      },
      zip_code: {
        //required
      },
    },
  },

  computed: {
    ...mapGetters({
      circleDiseaseTypes: "Circle/circleDiseaseTypes",
    }),
    // checkAllFieldsFilled() {
    //   return isAgeVerify
    //   && /[^0-9]/.test(formResponses.displayName)
    //   && formResponses.city
    //   && formResponses.zip_code
    //   && formResponses.displayName.length >= 6
    // }
  },

  created() {
    // console.log("authUser.user.dob ->", this.authUser.user.dob);
    this.fillDataIfAuthorized()
    // this.formResponses.role = this.$route.params.role
    this.getLocations("")
    this.formResponses.role = this.$route.query.role
    this.$store.dispatch("Circle/diseaseTypes", { type: this.currentCircle.id })
    // console.log("(created) circleDiseaseTypes ->", this.circleDiseaseTypes)
    setTimeout(() => {
      document.getElementsByTagName("body")[0].setAttribute("style", "height: auto")
    }, 500)
    this.maxBirthdayDate = this.moment().subtract(18, "years")
    // console.log("maxBirthdayDate ->", this.maxBirthdayDate)
  },

  mounted() {
    this.changeSvgColor()
    // this.getAllCountries()
    // this.getAllStates()
    // this.getLocations('')
    window.scrollTo(0, 0)
    // this.focusInput();
  },

  updated() {
    this.changeSvgColor()
    // console.log("(updated) circleDiseaseTypes ->", this.circleDiseaseTypes);
  },

  methods: {
    // focusInput() {
    //   const input = this.$refs.displayNameInput;
    //   console.log(input, "input ref");
    //   this.$refs.displayNameInput.focus();
    // },
    disabledDiagnosisDates(curr) {
      return curr >= new Date() || curr <= new Date(this.formResponses.birthDate || "")
    },
    // handleAdvocateModal() {
    //   this.$refs.AddAdvocateModal.showModal(this.currentCircle.id)
    // },
    fillDataIfAuthorized() {
      // console.log("fillDataIfAuthorized - authUser.user ->", this.authUser.user)
      if (this.authUser.user) {
        this.authenticated = true
        const user = this.authUser.user
        // console.log("existing user ->", user)
        this.formResponses.email = user.email
        if (this.$route.query.role === "caregiver") {
          this.formResponses.birthDate = new Date(user.dob) || null
        } else if (this.$route.query.role === "patient") {
          this.formResponses.birthDate = user.dob ? (this.moment(user.dob).isBefore(this.moment().subtract(18, "years")) ? new Date(user.dob) : this.moment().subtract(18, "years")) : null
        } else {
          this.formResponses.birthDate = null
        }
        // this.formResponses.birthDate = user.dob && this.$route.query.role === "caregiver" ? user.dob : null
        this.formResponses.gender = user.gender || ""
        if (user.location && user.location.length) {
          // console.log("fillDataIfAuthorized -> location", user.location)
          this.formResponses.city = user.location[0].city || undefined
          this.formResponses.state = user.location[0].state || undefined
          // this.formResponses.country = user.location[0].country || undefined
          this.formResponses.zip_code = user.location[0].zip_code || undefined
          if (user.location[0].city) {
            this.getZipCodes(user.location[0].city)
          }
        }
      }
      if (!this.authUser) {
        this.formResponses.email = null
        this.formResponses.password = null
      }
      // console.log(
      //   "formResponses.birthDate after fillDataIfAuthorized() ->",
      //   this.formResponses.birthDate
      // )
      // console.log("formResponses.city after fillDataIfAuthorized() ->", this.formResponses.city)
      // console.log("formResponses.state after fillDataIfAuthorized() ->", this.formResponses.state)
    },

    onCheck(e) {
      // console.log(e.target.checked, "<- isAgeVerify")
      this.isAgeVerify = e.target.checked
    },

    // getAllCountries() {
    //   AppRepository.getAllCountries()
    //     .then(res => {
    //       this.country = res.data.data
    //     })
    //     .catch(err => null)
    // },

    async getLocations(city) {
      try {
        this.loadingLocation = true
        const coreLocationResponse = await axios.get(`${process.env.SSO_BASE_URL}/api/v2/dovescore/city/?name=${city}`)
        this.locationsList = coreLocationResponse.data.results || []
        this.loadingLocation = false
      } catch (e) {
        this.loadingLocation = false
        this.$notification.error({ message: "Try Again", description: "Error while fetching location" })
      }
    },

    async selectLocation(val) {
      const value = JSON.parse(val)
      this.formResponses.city = value.name
      this.formResponses.state = value.state
      this.formResponses.zip_code = undefined
      this.getZipCodes(value.name)
    },

    async getZipCodes(city) {
      try {
        this.loadingZipCodes = true
        const zipCodeRes = await axios.get(`${process.env.SSO_BASE_URL}/api/v2/dovescore/zipcode/?page_size=50&city=${city}`)
        this.zipCodeArray = zipCodeRes.data.results.map(data => data.zipCode) || []
        this.loadingZipCodes = false
      } catch (e) {
        this.loadingZipCodes = false
        this.$notification.error({ message: "Try Again", description: "Error while fetching zip codes" })
      }
    },
    // getAllStates() {
    //   AppRepository.getAllStates()
    //     .then(res => {
    //       this.state = res.data.data
    //     })
    //     .catch(err => null)
    // },

    // disabledDate(current) {
    //   return current && current > this.moment().endOf("day")
    // },
    redirectBack() {
      this.$router.go(-1)
    },
    // handleTags(value) {
    //   this.formResponses.additionalConditions = value
    //   this.$v.formResponses.additionalConditions.$touch()
    // },
    // changeColor(value) {
    //   setTimeout(() => {
    //     this.$el
    //       .querySelectorAll(".c-select")[0]
    //       .children[0].children[0].querySelector("ul")
    //       .querySelectorAll("li")
    //       .forEach(elem => {
    //         if (elem.classList.contains("ant-select-selection__choice")) {
    //           elem.setAttribute("style", ` background: ${this.currentCircle.color_code} !important `)
    //         }
    //       })
    //   }, 100)
    // },

    changeSvgColor() {
      this.$el.querySelectorAll(".ant-calendar-picker-icon").forEach(elem => {
        elem.children[0].setAttribute("fill", this.currentCircle.color_code)
      })
      this.$el.querySelectorAll(".ant-select-arrow-icon").forEach(elem => {
        elem.children[0].setAttribute("fill", this.currentCircle.color_code)
      })
    },

    handleDiagnosisDateChange(date, dateString) {
      this.formResponses.diagnosisDate = dateString ? dateString + "-01" : null
      this.$v.formResponses.diagnosisDate.$touch()
    },
    handleBirthDateChange(date, dateString) {
      this.formResponses.birthDate = dateString ? dateString + "-01" : null
      this.$v.formResponses.birthDate.$touch()
      if (this.formResponses.diagnosisDate && new Date(date) > new Date(this.formResponses.diagnosisDate)) {
        this.formResponses.diagnosisDate = dateString ? dateString + "-01" : null
      }
    },
    handleSubmit() {
      // this.$router.push({
      //         name: "UserSymptoms",
      //         query: { role: this.formResponses.role },
      //       })
      // return
      const key = this.formResponses.role === "patient" ? "normal_user" : "caregiver"

      const payload = {
        email: this.formResponses.email,
        password: this.formResponses.password,
        // first_name: this.setName("first", this.formResponses.displayName),
        // middle_name: this.setName("middle", this.formResponses.displayName),
        // last_name: this.setName("last", this.formResponses.displayName),
        first_name: this.formResponses.displayName.split(" ")[0],
        middle_name: "",
        last_name: this.formResponses.displayName
          .split(" ")
          .slice(1)
          .join(" "),
        phone_number: null,
        display_name: this.formResponses.displayName,
        gender: this.formResponses.gender,
        dob: this.moment(this.formResponses.birthDate).format("YYYY-MM-DD"),
        // dob: this.formResponses.birthDate,
        role: this.formResponses.role,
        [key]: {
          add_conditions: this.formResponses.additionalConditions ? this.formResponses.additionalConditions : [],
          diagnosis_date: this.formResponses.diagnosisDate ? this.moment(this.formResponses.diagnosisDate).format("YYYY-MM-DD") : null,
          // diagnosis_date: this.formResponses.diagnosisDate,
          disease_type: this.formResponses.ibsType,
        },
        user_circle: {
          circle: this.currentCircle.id,
        },
        location: {
          address_line1: this.formResponses.address_line1,
          address_line2: this.formResponses.address_line2,
          city: this.formResponses.city,
          state: this.formResponses.state,
          country: this.formResponses.country,
          zip_code: this.formResponses.zip_code || "",
        },
        send_updates: this.$route.query.send_updates === "true" ? true : false,
      }

      this.empty = !this.$v.formResponses.$anyDirty
      this.errors = this.$v.formResponses.$anyError
      this.uiState = "submit_clicked"

      if (this.errors === false && this.empty === false && payload.location.city) {
        this.loading = true

        this.$store
          .dispatch("Signup/createUser", { payload })
          .then(data => {
            this.uiState = "form_submitted"
            if (this.formResponses.role === "caregiver" || this.formResponses.role === "patient") {
              this.$notification.success({ message: "New Account Created", description: "Your user account has been created, please provide additional information in the following pages." })
            }

            const user = JSON.parse(localStorage.getItem("user"))

            Repository.defaults.headers.common["Authorization"] = `Bearer ${user.user.token}`
            this.loading = false

            // this.$router.replace({
            //   name: "UserSymptoms",
            //   query: { role: this.formResponses.role }
            // });
            this.$router.push({ name: "UserSymptoms", query: { role: this.formResponses.role } })
          })
          .catch(error => {
            // console.log(error, "error")
            this.loading = false
            this.$notification.error({ message: "Error", description: error })
          })
      } else {
        this.$notification.error({ message: "Error", description: "You need to fill all the fields correctly to create your account and proceed further." })
      }
    },

    toggleProvideInfo(e) {
      this.provideInfo = e.target.checked
      // console.log("provideInfo ->", provideInfo)
    },
    handleTypeChange(type) {
      if (type.suggest_circles && type.suggest_circles.length) {
        CircleRepository.getCircleByKeyName(type.suggest_circles[0]).then(res => {
          this.suggested_circle = res.data.data[0]
          this.$refs.suggestCircle.show({ ...this.suggested_circle, selected_type: type.display_name })
        })
      }
    },
  },
}
</script>

<style lang="scss" scoped>
body {
  height: auto !important;
}

.welcome-message {
  font-size: 36px;
  font-weight: 700;
  margin-top: 0 !important;
}

.get-started {
  color: #647490;
  font-size: 16px;
  font-weight: 400;
}

.profile-form {
  margin-top: 48px;
  .question-icon {
    font-size: 20px;
    margin: 0 6px;
    cursor: pointer;
  }
  .form-caregiver-wrapper {
    display: flex;
    @media screen and (max-width: 900px) {
      flex-direction: column;
    }
  }
  &__card {
    padding: 16px;
    margin: 24px 0;
    width: 100%;
    background: #f8fafd;
    box-shadow: 0px 2px 8px rgba(60, 60, 60, 0.1);
    border-radius: 4px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .user-wrapper {
      display: flex;
      align-items: center;
    }
    .registering-message {
      color: #647490;
      font-size: 16px;
      font-weight: 400;
      margin: 0 16px;
      text-align: left;
    }
    .user-avatar {
      width: 40px;
      height: 40px;
      border-radius: 50%;
      background: #f1f5f9;
      display: flex;
      justify-content: center;
      align-items: center;
      // img {
      //   width: 15px;
      //   height: 15px;
      // }
    }
    .change {
      // color: #2A71D4;
      font-size: 14px;
      font-weight: 700;
      cursor: pointer;
    }
  }

  .input-label {
    color: #647490;
    font-weight: 700;
  }
  .formInput {
    padding: 16px;
    height: 56px;
  }
  .ant-calendar-picker-input {
    height: 56px;
  }
  .ant-select-selection {
    &__rendered {
      margin: 0 16px;
      height: 56px;
    }
  }
  .ant-select-lg .ant-select-selection--single {
    height: 56px;
  }
}
.formWrapper {
  padding: 0;
}

.desc-card {
  padding: 24px 30px;
  border-radius: 2px;
  background-color: #f3f7fd;
  text-align: left;
  height: 95%;
  h3 {
    color: #333333;
    font-family: Lato;
    font-size: 21px;
    font-weight: bold;
    padding-bottom: 16px;
    line-height: 1;
    margin: 0;
  }
  p {
    color: #333333;
    font-family: Lato;
    font-size: 16px;
    margin: 0;
  }
}
.pat_info {
  text-align: left;
  margin: 20px 0;
  h2 {
    color: #333333;
    font-family: Lato;
    font-size: 21px;
    font-weight: bold;
    margin-bottom: 8px;
  }
  span {
    color: #4d4d4d;
    font-family: Lato;
    font-size: 16px;
    font-weight: bold;
    margin-left: 10px;
  }
}
.switch-adv {
  padding: 12px 20px;
  border-radius: 11px;
  margin-bottom: 40px;
  cursor: pointer;
  p {
    color: #333333;
    font-family: Lato;
    font-size: 16px;
    margin-bottom: 0;
  }
  div {
    border-radius: 8px;
    padding: 11px 35px;
    color: #ffffff;
    font-family: Lato;
    font-size: 16px;
    font-weight: bold;
    max-width: 260px;
    margin: 20px auto;
    text-transform: uppercase;
    line-height: 1;
  }
}
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  appearance: none;
  margin: 0;
}

/* Firefox */
input[type="number"] {
  -moz-appearance: textfield;
  appearance: none;
}
.required {
  color: tomato !important;
}
.buttons-groups {
  display: flex;
  justify-content: space-between;
  padding: 1px;

  @media screen and (max-width: 900px) {
    flex-direction: column;
  }
}
.checkbox-verify {
  display: flex;
  align-items: center;
}
.dovemed-button {
  padding: 12px 24px;
  cursor: pointer;
  border-radius: 8px;
  // @media screen and (max-width: 900px) {
  //   margin-top: 16px;
  // }
}
.next-button {
  background: #a1bde6;
  border-radius: 8px;
  margin: 0 10px;
  padding: 12px 24px;
}

.ant-calendar-month-panel-cell-disabled .ant-calendar-month-panel-month {
  filter: blur(2px) !important;
}
.ant-calendar-month-panel-table {
  .ant-calendar-month-panel-tbody {
    .ant-calendar-month-panel-cell-disabled,
    td.ant-calendar-month-panel-cell-disabled {
      .ant-calendar-month-panel-month,
      a.ant-calendar-month-panel-month {
        filter: blur(2px) !important;
        opacity: 0 !important;
      }
    }
  }
}
.search-icon {
  left: 25px;
  top: 45px;
  z-index: 1;
}
.green {
  color: limegreen !important;
}
.red {
  color: tomato !important;
}
@media screen and (max-width: 900px) {
  .mt-5 {
    margin-top: 16px !important;
  }
  .btn-cont {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 48px;
    button {
      width: 50% !important;
    }
    .next-button {
      margin-right: 0 !important;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Signup/UserProfile/Welcome.vue